<template>
  <div>
    <public-header v-if="!isLoggedIn" />
    <featured-provider />
    <accounts-header v-if="isLoggedIn" />
    <accounts />
    <recommendations />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Accounts from '@/components/list/Accounts'
  import AccountsHeader from '@/components/list/AccountsHeader'
  import PublicHeader from '@/components/list/PublicHeader'
  import Recommendations from '@/components/recommendations/Index'
  import FeaturedProvider from './FeaturedProvider'

  export default {
    computed: {
      ...mapGetters('user', ['isLoggedIn'])
    },
    components: {
      Accounts,
      AccountsHeader,
      PublicHeader,
      Recommendations,
      FeaturedProvider
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/list/Index.vue